import { Type } from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';
import { AuditStatusSchema } from '../audit-status.js';
import { NumericSchema } from '../common.js';
import { SupportedDexSchema } from '../supported-dex.js';
import { PoolPeriodSchema } from './pool-period.js';
export var SortBy;
(function (SortBy) {
    SortBy["GainScore"] = "gainScore";
    SortBy["HoldersCount"] = "holdersCount";
    SortBy["TxCount"] = "txCount";
    SortBy["CreatedAt"] = "createdAt";
    SortBy["LiquidityInUsd"] = "liquidityInUsd";
    SortBy["MarketCapUsd"] = "marketCapUsd";
    SortBy["MigrationTimestamp"] = "extraDetails.migration.migrationTimestamp";
    SortBy["VolumeInUsd"] = "volumeInUsd";
    SortBy["NetVolumeInUsd"] = "netVolumeInUsd";
    SortBy["HoldersChangePercents"] = "holdersChangePercents";
    SortBy["PriceChangePercents"] = "priceChangePercents";
})(SortBy || (SortBy = {}));
export var SortDirection;
(function (SortDirection) {
    SortDirection["Asc"] = "asc";
    SortDirection["Desc"] = "desc";
})(SortDirection || (SortDirection = {}));
export const SortDirectionSchema = Type.Union([
    Type.Literal(SortDirection.Asc),
    Type.Literal(SortDirection.Desc),
]);
export const SortBySchema = Type.Union([
    Type.Literal(SortBy.GainScore),
    Type.Literal(SortBy.HoldersCount),
    Type.Literal(SortBy.TxCount),
    Type.Literal(SortBy.CreatedAt),
    Type.Literal(SortBy.LiquidityInUsd),
    Type.Literal(SortBy.MarketCapUsd),
    Type.Literal(SortBy.MigrationTimestamp),
    Type.Literal(SortBy.VolumeInUsd),
    Type.Literal(SortBy.NetVolumeInUsd),
    Type.Literal(SortBy.HoldersChangePercents),
    Type.Literal(SortBy.PriceChangePercents),
]);
export const ExplorePoolsFiltersSchema = Type.Object({
    period: Type.Optional(PoolPeriodSchema),
    keywords: Type.Optional(Type.Array(Type.String(), { maxItems: 5 })),
    minDevHolding: Type.Optional(NumericSchema),
    maxDevHolding: Type.Optional(NumericSchema),
    minTop10Holding: Type.Optional(NumericSchema),
    maxTop10Holding: Type.Optional(NumericSchema),
    minInsidersHolding: Type.Optional(NumericSchema),
    maxInsidersHolding: Type.Optional(NumericSchema),
    minBundlersHolding: Type.Optional(NumericSchema),
    maxBundlersHolding: Type.Optional(NumericSchema),
    minSnipersHolding: Type.Optional(NumericSchema),
    maxSnipersHolding: Type.Optional(NumericSchema),
    minHolders: Type.Optional(NumericSchema),
    maxHolders: Type.Optional(NumericSchema),
    minTx: Type.Optional(NumericSchema),
    maxTx: Type.Optional(NumericSchema),
    audit: Type.Optional(AuditStatusSchema),
    createdAfter: Type.Optional(Type.String({ format: 'date-time' })),
    createdBefore: Type.Optional(Type.String({ format: 'date-time' })),
    minMarketCapInUsd: Type.Optional(NumericSchema),
    maxMarketCapInUsd: Type.Optional(NumericSchema),
    minLiquidityInUsd: Type.Optional(NumericSchema),
    maxLiquidityInUsd: Type.Optional(NumericSchema),
    minVolumeInUsd: Type.Optional(NumericSchema),
    maxVolumeInUsd: Type.Optional(NumericSchema),
    // Pool fee = fees.totalFees (network + priority + bundle tip, native units).
    minFee: Type.Optional(NumericSchema),
    maxFee: Type.Optional(NumericSchema),
    minSplashPoints: Type.Optional(NumericSchema),
    maxSplashPoints: Type.Optional(NumericSchema),
    minBoosters: Type.Optional(NumericSchema),
    maxBoosters: Type.Optional(NumericSchema),
    sortBy: Type.Optional(SortBySchema),
    sortDir: Type.Optional(SortDirectionSchema),
    supportedDex: Type.Optional(Type.Array(SupportedDexSchema)),
    hasTwitter: Type.Optional(Type.Boolean()),
    hasWebsite: Type.Optional(Type.Boolean()),
    hasTelegram: Type.Optional(Type.Boolean()),
    hasAtLeastOneSocial: Type.Optional(Type.Boolean()),
    withMayhem: Type.Optional(Type.Boolean()),
    onlyMayhem: Type.Optional(Type.Boolean()),
    premiumTokenAddresses: Type.Optional(Type.Array(Type.String())),
});
export const sanitizeExplorePoolsFilters = (input) => {
    if (!input || typeof input !== 'object') {
        return null;
    }
    const cleaned = Value.Clean(ExplorePoolsFiltersSchema, structuredClone(input));
    if (!Value.Check(ExplorePoolsFiltersSchema, cleaned)) {
        return null;
    }
    return cleaned;
};
//# sourceMappingURL=filters.js.map